import { FilterTypesKeys } from './schemaEditor';

export default [
  {
    value: FilterTypesKeys.FILTER_EQ,
    label: 'IsEqualTo',
    help: {
      desc: 'Returns boolean true if both input expressions or values are equal.',
      ex: 'IsEqual(1,1)  ➠ true',
    },
    requiredParams: ['value', 'withAttr'],
    params: [
      {
        name: 'value',
        display_name: 'Value',
        desc: 'The first expression or value that needs to be compared with the second value.',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
      {
        name: 'withAttr',
        display_name: 'Equal To',
        desc: 'The second expression or value to test first value against.',
        typesAllowed: ['string', 'number', 'boolean'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_NEQ,
    label: 'IsNotEqualTo',
    help: {
      desc: 'Returns boolean true if the input expressions or values are not equal.',
      ex: 'IsNotEqual(1,2)  ➠ true',
    },
    requiredParams: ['value', 'withAttr'],
    params: [
      {
        name: 'value',
        display_name: 'Value',
        desc: 'The first expression or value that needs to be compared with the second value.',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
      {
        name: 'withAttr',
        display_name: 'Not Equal To',
        desc: 'The second expression or value to test first value against.',
        typesAllowed: ['string', 'number', 'boolean'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_LT,
    label: 'IsLessThan',
    help: {
      desc: 'Returns boolean true if first value is less than the second value',
      ex: 'IsLessThan(1,2)  ➠ true',
    },
    requiredParams: ['value', 'withAttr'],
    params: [
      {
        name: 'value',
        display_name: 'Value',
        desc: 'The first expression or value that needs to be compared with the second value.',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
      {
        name: 'withAttr',
        display_name: 'Less Than',
        desc: 'The second expression or value to test first value against.',
        typesAllowed: ['string', 'number', 'boolean'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_GT,
    label: 'IsGreaterThan',
    help: {
      desc: 'Returns boolean true if first value is greater than the second value',
      ex: 'IsGreaterThan(1,2)  ➠ true',
    },
    requiredParams: ['value', 'withAttr'],
    params: [
      {
        name: 'value',
        display_name: 'Value',
        desc: 'The first expression or value that needs to be compared with the second value.',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
      {
        name: 'withAttr',
        display_name: 'Greater Than',
        desc: 'The second expression or value to test first value against.',
        typesAllowed: ['string', 'number', 'boolean'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_IS_NULL,
    label: 'IsNull',
    help: {
      desc: 'Returns boolean true if the input expression or value is null.',
      ex: 'IsNull(null)  ➠ true',
    },
    requiredParams: ['value'],
    params: [
      {
        name: 'value',
        display_name: 'Value',
        desc: 'The expression or value that needs to be checked for null.',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_NOT_NULL,
    label: 'IsNotNull',
    help: {
      desc: 'Returns boolean true if the input expression or value is not null.',
      ex: 'IsNotNull(null)  ➠ true',
    },
    requiredParams: ['value'],
    params: [
      {
        name: 'value',
        display_name: 'Value',
        desc: 'The expression or value that needs to be checked for null.',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_ARR_CONTAINS,
    label: 'InArray',
    help: {
      desc: 'Returns boolean true if the first value is an array and the second value is present in the array.',
      ex: 'InArray([1,2,3],2)  ➠ true',
    },
    requiredParams: ['value', 'withAttr'],
    params: [
      {
        name: 'value',
        display_name: 'Array',
        desc: 'The array that needs to be checked for the second value',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
      {
        name: 'withAttr',
        display_name: 'Value',
        desc: 'The value to check if it is present in the array',
        typesAllowed: ['string', 'number', 'boolean'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_ARR_DOESNT_CONTAIN,
    label: 'NotInArray',
    help: {
      desc: 'Returns boolean true if the first value is an array and the second value is not present in the array.',
      ex: 'NotInArray([1,2,3],2)  ➠ true',
    },
    requiredParams: ['value', 'withAttr'],
    params: [
      {
        name: 'value',
        display_name: 'Array',
        desc: 'The array that needs to be checked for the value',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
      {
        name: 'withAttr',
        display_name: 'Value',
        desc: 'The value to check if it is not present in the array',
        typesAllowed: ['string', 'number', 'boolean'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_IS_PRESENT,
    label: 'InRecord',
    help: {
      desc: 'Returns boolean true if the value is present in the record',
      ex: 'InRecord(2)  ➠ true',
    },
    requiredParams: ['value'],
    params: [
      {
        name: 'value',
        display_name: 'Attribute',
        desc: 'The attribute to check if it is present in the record',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_IS_NOT_PRESENT,
    label: 'NotInRecord',
    help: {
      desc: 'Returns boolean true if the value is not present in the record',
      ex: 'NotInRecord(2)  ➠ true',
    },
    requiredParams: ['value'],
    params: [
      {
        name: 'value',
        display_name: 'Attribute',
        desc: 'The attribute to check if it is not present in the record',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
          boolean: false,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: FilterTypesKeys.FILTER_REGEX_CONTAINS,
    label: 'MatchesPattern',
    help: {
      desc: 'Returns boolean true if the value matches the pattern',
      ex: 'MatchesPattern("hello", "he.*")  ➠ true',
    },
    requiredParams: ['value', 'withAttr'],
    params: [
      {
        name: 'value',
        display_name: 'Value',
        desc: 'The expression or value that needs to be checked for the pattern',
        typesAllowed: ['attributeRef'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
      {
        name: 'withAttr',
        display_name: 'Pattern',
        desc: 'The pattern to match the value against.',
        typesAllowed: ['string'],
        inputElement: 'text',
        format: 'string',
        default: {
          string: '',
          number: 0,
        },
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: 'and?',
    label: 'And',
    help: {
      desc: 'Returns boolean true if both inputs evaluate to true',
      ex: 'And(true,false)  ➠ false',
    },
    requiredParams: ['values'],
    params: [
      {
        name: 'values',
        display_name: 'Values',
        desc: 'The expressions that should be joined with the AND operator',
        typesAllowed: ['function'],
        inputElement: 'restParams',
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
  {
    value: 'or?',
    label: 'Or',
    help: {
      desc: 'Returns boolean true if either input evaluates to true',
      ex: 'Or(true,false)  ➠ true',
    },
    requiredParams: ['values'],
    params: [
      {
        name: 'values',
        display_name: 'Values',
        desc: 'The expressions that should be joined with the OR operator',
        typesAllowed: ['function'],
        inputElement: 'restParams',
      },
    ],
    ignoreSrc: true,
    withOrWithoutDest: true,
  },
];
